import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, 
    {
      path: '/contact',
      name: 'contact',
      component: resolve => require(['@/view/contact/contact'], resolve),
    },
    {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        }, 
        // {
        //   path: '/ai',
        //   name: 'ai',
        //   component: resolve => require(['@/view/ai'], resolve),
        //   meta: {
        //     title: 'AI产品'
        //   }
        // },
        // {
        //   path: '/message',
        //   name: 'message',
        //   component: resolve => require(['@/view/message'], resolve),
        //   meta: {
        //     title: '通讯产品'
        //   }
        // },
        // {
        //   path: '/sms',
        //   name: 'sms',
        //   component: resolve => require(['@/view/sms'], resolve),
        //   meta: {
        //     title: '短信产品'
        //   }
        // },
        // {
        //   path: '/resource',
        //   name: 'resource',
        //   component: resolve => require(['@/view/resource'], resolve),
        //   meta: {
        //     title: '资源'
        //   }
        // },
        // {
        //   path: '/solution',
        //   name: 'solution',
        //   component: resolve => require(['@/view/solution'], resolve),
        //   meta: {
        //     title: '解决方案'
        //   }
        // },
        // {
        //   path: '/software',
        //   name: 'software',
        //   component: resolve => require(['@/view/Software'], resolve),
        //   meta: {
        //     title: '软件产品'
        //   },
        //   children: [
        //     {
        //       path: '/software',
        //       redirect: '/software/smartTown'
        //     },
        //     {
        //       path: '/software/smartTown',
        //       name: 'software',
        //       component: resolve => require(['@/view/Software_smartTown'], resolve),
        //       meta: {
        //         title: '软件产品丨智能小镇管理系统'
        //       }
        //     },
        //     {
        //       path: '/software/bigData',
        //       name: 'software',
        //       component: resolve => require(['@/view/Software_bigData'], resolve),
        //       meta: {
        //         title: '软件产品丨大数据管理系统'
        //       }
        //     }
        //   ]
        // }, 
        // {
        //   path: '/service',
        //   name: 'service',
        //   component: resolve => require(['@/view/Service'], resolve),
        //   meta: {
        //     title: '相关服务'
        //   }
        // }, 
        // {
        //   path: '/aboutUs',
        //   name: 'aboutUs',
        //   component: resolve => require(['@/view/aboutUs'], resolve),
        //   meta: {
        //     title: '关于'
        //   }
        // },
        // {
        //   path: '/newsinformation',
        //   name: 'newsinformation',
        //   component: resolve => require(['@/view/NewsInformation'], resolve),
        //   meta: {
        //     title: '新闻动态'
        //   }
        // }, {
        //   path: '/companyintroduction',
        //   name: 'companyintroduction',
        //   component: resolve => require(['@/view/CompanyIntroduction'], resolve),
        //   meta: {
        //     title: '公司介绍'
        //   }
        // }, {
        //   path: '/jobchance',
        //   name: 'jobchance',
        //   component: resolve => require(['@/view/JobChance'], resolve),
        //   meta: {
        //     title: '工作机会'
        //   }
        // }, {
        //   path: '/contactus',
        //   name: 'contactus',
        //   component: resolve => require(['@/view/ContactUs'], resolve),
        //   meta: {
        //     title: '联系我们'
        //   }
        // },
        // {
        //   path: '/servicedetail',
        //   name: 'servicedetail',
        //   component: resolve => require(['@/view/ServiceDetail'],resolve),
        //   meta: {
        //     title: '相关服务'
        //   }
        // }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js